import { render, staticRenderFns } from "./SpecialList.vue?vue&type=template&id=8c8e9c0e&"
import script from "./SpecialList.vue?vue&type=script&lang=ts&"
export * from "./SpecialList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports